import { Route, Routes } from "react-router-dom";
import { OSCI0201001Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201001Q";
import { OSCI0201002S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201002S";
import { OSCI0201015Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201015Q";
import { OSCI0201016S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201016S";
import { OSCI0201003Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201003Q";
import { OSCI0201004S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201004S";
import { OSCI0201005S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201005S";
import { OSCI0201009Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201009Q";
import { OSCI0201010S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201010S";
import { OSCI0201011S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201011S";
import { OSCI0201012Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201012Q";
import { OSCI0201013S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201013S";
import { OSCI0201014S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201014S";
import { OSCI0201017Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201017Q";
import { OSCI0201018S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201018S";
import { OSCI0201019S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201019S";
import { OSCI0201031Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201031Q";
import { OSCI0201032S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201032S";
import { OSCI0201033S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201033S";
import { OSCI0201023Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201023Q";
import { OSCI0201024S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201024S";
import { OSCI0201025S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201025S";
import { OSCI0201006Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201006Q";
import { OSCI0201007S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201007S";
import { OSCI0201008S } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201008S";
import { OSCI0201020Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201020Q";
import { OSCI0201021S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201021S";
import { OSCI0201022S } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201022S";
import { OSCI0201026Q } from "../app/asin/OSCI0201026Q";
import { OSCI0201027S } from "../app/asin/OSCI0201027S";
import { OSCI0201028S } from "../app/asin/OSCI0201028S";
import { OSCI0201029Q } from "@/tz/go/egaz/osci/lpco/app/new/OSCI0201029Q";
import { OSCI0201030Q } from "@/tz/go/egaz/osci/lpco/app/amd/OSCI0201030Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const OsciLpcoAprvRouter = () => {
    return (
        <Routes>
            {/*  !== LPCO 승인 ==! */}
            <Route path="/new/osci0201001q" element={<OSCI0201001Q />} />
            <Route path="/new/osci0201002s/:appId" element={<OSCI0201002S />} />
            <Route path="/amd/osci0201015q" element={<OSCI0201015Q />} />
            <Route path="/amd/osci0201016s/:appId" element={<OSCI0201016S />} />
            <Route path="/new/osci0201003q" element={<OSCI0201003Q />} />
            <Route path="/new/osci0201004s/:appId" element={<OSCI0201004S />} />
            <Route path="/new/osci0201004s/:appNo/:appDgr" element={<OSCI0201004S />} />
            <Route path="/new/osci0201005s" element={<OSCI0201005S />} />
            <Route path="/new/osci0201009q" element={<OSCI0201009Q />} />
            <Route path="/new/osci0201010s/:appId" element={<OSCI0201010S />} />
            <Route path="/new/osci0201010s/:appNo/:appDgr" element={<OSCI0201010S />} />
            <Route path="/new/osci0201011s" element={<OSCI0201011S />} />
            <Route path="/new/osci0201012q" element={<OSCI0201012Q />} />
            <Route path="/new/osci0201013s/:appId" element={<OSCI0201013S />} />
            <Route path="/new/osci0201013s/:appNo/:appDgr" element={<OSCI0201013S />} />
            <Route path="/new/osci0201014s" element={<OSCI0201014S />} />
            <Route path="/amd/osci0201017q" element={<OSCI0201017Q />} />
            <Route path="/amd/osci0201018s/:appId" element={<OSCI0201018S />} />
            <Route path="/amd/osci0201018s/:appNo/:appDgr" element={<OSCI0201018S />} />
            <Route path="/amd/osci0201019s" element={<OSCI0201019S />} />
            <Route path="/amd/osci0201031q" element={<OSCI0201031Q />} />
            <Route path="/amd/osci0201032s/:appId" element={<OSCI0201032S />} />
            <Route path="/amd/osci0201032s/:appNo/:appDgr" element={<OSCI0201032S />} />
            <Route path="/amd/osci0201033s" element={<OSCI0201033S />} />
            <Route path="/amd/osci0201023q" element={<OSCI0201023Q />} />
            <Route path="/amd/osci0201024s/:appId" element={<OSCI0201024S />} />
            <Route path="/amd/osci0201024s/:appNo/:appDgr" element={<OSCI0201024S />} />
            <Route path="/amd/osci0201025s" element={<OSCI0201025S />} />
            <Route path="/new/osci0201006q" element={<OSCI0201006Q />} />
            <Route path="/new/osci0201007s/:appId" element={<OSCI0201007S />} />
            <Route path="/new/osci0201007s/:appNo/:appDgr" element={<OSCI0201007S />} />
            <Route path="/new/osci0201008s" element={<OSCI0201008S />} />
            <Route path="/amd/osci0201020q" element={<OSCI0201020Q />} />
            <Route path="/amd/osci0201021s/:appId" element={<OSCI0201021S />} />
            <Route path="/amd/osci0201021s/:appNo/:appDgr" element={<OSCI0201021S />} />
            <Route path="/amd/osci0201022s" element={<OSCI0201022S />} />
            {/* Application Assignor Modification !== 신청서 배정 목록 ==! */}
            <Route path="/asin/osci0201026q" element={<OSCI0201026Q />} />
            {/* Application Assignment Modification !== 신청서 배정자 수정 ==! */}
            <Route path="/asin/osci0201027s/:appId" element={<OSCI0201027S />} />
            {/* Joint Inspection Assignment Modification !== 신청서 배정자 수정 ==! */}
            <Route path="/asin/osci0201028s/:tansadNo" element={<OSCI0201028S />} />
            {/* Application Approval Request !== 신청서 결재 요청 ==! */}
            <Route path="/new/osci0201029q" element={<OSCI0201029Q />} />
            <Route path="/new/osci0201029q/:appId" element={<OSCI0201029Q />} />
            {/* Amend Application Approval Request !== 정정 신청서 결재 요청 ==! */}
            <Route path="/amd/osci0201030q" element={<OSCI0201030Q />} />
            <Route path="/amd/osci0201030q/:appId" element={<OSCI0201030Q />} />
        </Routes>
    );
};
